import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { ApiMailLayoutHelperService } from './mail-layout-helper.service';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ApiMailLayoutService {
  constructor(
    public hpr: ApiMailLayoutHelperService,
    private _api: ApiService
  ) {}

  get(id: number | string) {
    return this._api.get('mail-layout/get/id/' + id);
  }

  list(data: any = {}) {
    return this._api.post('mail-layout/list', data);
  }

  create(data: any) {
    return this._api.post('mail-layout/create', data);
  }

  update(data: any) {
    return this._api.post('mail-layout/update', data);
  }

  remove(id: number) {
    return this._api.post('mail-layout/remove/id/' + id);
  }

  autocompleteSource(data = {}) {
    return (text?: string, id?: number) => {
      return this.list(
        text !== null
          ? { ...data, text }
          : { ids: Array.isArray(id) ? id : [id] }
      ).pipe(
        map((result) =>
          result.data.map((item: any) => {
            return {
              id: item.id,
              label: item.name,
              data: item,
            };
          })
        )
      );
    };
  }
}
